import { render } from "./UserUpdate.vue?vue&type=template&id=5d5749e6"
import script from "./UserUpdate.vue?vue&type=script&lang=js"
export * from "./UserUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gimmetm/work/projects/tnms-go/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__